import React, { Fragment, useEffect, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, Card, CardBody, CardFooter, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import ReactTableGeneric from "Components/ReactTableGeneric";
import Loader from "react-loaders";
import { ReactComponent as DeleteIcon } from "../../../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as AddIcon } from "../../../../assets/utils/images/svgs/addBlue.svg";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { Formik } from "formik";
import * as Yup from "yup";
import InstellingenFeatureService from "Api/Instellingen/Features";
import CoordinatorInstellingenService from "Api/Instellingen";
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";
import { useApiMutation } from "services/useApiMutation";
import useSWR from "swr";

const validationSchema = Yup.object().shape({
    functies: Yup.string().required('Selecteer een optie'),
    eExclude_wwz: Yup.string().required('Selecteer een optie'),
});

const Features = () => {
    const [showAlert, setShowAlert] = useState(false);
    const [communityId, setCommunityId] = useState('');
    const [functionModal, setFuntionModal] = useState(false);
    const [currentSubGrpId, setCurrentSubGrpId] = useState('');
    const [loadingKeys, setLoadingKeys] = useState({});
    const { trigger: saveFeatureMutation } = useApiMutation();
    const { trigger: deleteFeatureMutation } = useApiMutation();
    const { trigger: toggleFeatureMutation } = useApiMutation();

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useSWR(
        "community-list",
        CoordinatorInstellingenService.communityList
    );

    const communityList =
        communityResponse?.data?.communityList || [];

    useEffect(() => {
        if (!communityId && communityList.length) {
            setCommunityId(
                communityList[0].iCommunityId
            );
        }
    }, [communityList, communityId]);

    const {
        data: featuresResponse,
        mutate: refreshFeatures,
        isLoading: featuresLoading,
    } = useSWR(
        communityId
            ? ["features", communityId]
            : null,
        ([, communityId]) =>
            InstellingenFeatureService.fetchFunctieData(
                communityId
            )
    );

    const featuresData =
        featuresResponse?.data?.data || {};



    const toggleFunctieHandler = (rowData, communityId, data) => {
        if ((data === "1" ? 'Yes' : 'No') === rowData?.eExclude_wwz) return;
        setLoadingKeys(prevLoadingKeys => {
            const updatedLoadingKeys = Object.fromEntries(
                Object.entries(prevLoadingKeys).filter(([_, value]) => value !== false)
            );

            return { ...updatedLoadingKeys, [rowData.iSubGroupId]: true };
        });
        const values = {
            iSubGroupId: rowData.iSubGroupId,
            iCommunityId: communityId,
            value: data === "0" ? "No" : "Yes"
        };
        toggleFeatureMutation(() =>
            InstellingenFeatureService.toggleFunctieValue(values)
        ).then((response) => {
            if (response.status) {
                refreshFeatures();
                setLoadingKeys(prev => ({
                    ...prev,
                    [rowData.iSubGroupId]: false
                }));
            } else {
                toast.error("Kan gegevens niet updaten");
            }
        }).catch(() => console.error)
    }

    const columns = [
        {
            header: () => 'Functies',
            accessorKey: 'vGroup',
        },
        {
            header: () => 'Uitzondering WWZ',
            accessorKey: 'eExclude_wwz',
            cell: (value) => {
                return <div className="cursor-pointer d-inline-flex justify-content-center">
                    {
                        loadingKeys[value.row?.original.iSubGroupId] ? (
                            <div className="spinner-icon-change">
                                <div><Spinner size="sm" color="primary" /></div>
                            </div>
                        ) :
                            (
                                <GroupStatus iconChangeHandler={(field, data) => toggleFunctieHandler(value.row.original, communityId, data)} data={value.row?.original.eExclude_wwz === 'Yes' ? 1 : 0} />
                            )
                    }
                </div>

            },
        },
        {
            header: () => 'Verwijderen',
            accessorKey: 'rows',
            cell: (value) => {
                return <DeleteIcon className="cursor-pointer" onClick={() => { setShowAlert(true); setCurrentSubGrpId(value.row.original.iSubGroupId) }} />
            },
        },
    ]

    const toggle = () => {
        setFuntionModal(prev => !prev);
    }

    const handleOrgSubmit = (values) => {
        const data = {
            iSubGroupId: values.functies,
            iCommunityId: communityId,
            value: values.eExclude_wwz
        };
        saveFeatureMutation(() =>
            InstellingenFeatureService.saveFeatureApi(data)).then((response) => {
                if (response.status) {
                    refreshFeatures();
                    setFuntionModal(false);
                } else {
                    toast.error("Er is iets misgegaan");
                }
            }).catch(() => console.error);
    }

    const deleteFunctieHandler = () => {
        deleteFeatureMutation(() =>
            InstellingenFeatureService.deleteFunctie(
                currentSubGrpId,
                communityId
            )
        ).then((response) => {
            if (response.status) {
                refreshFeatures();
            } else {
                toast.error("Er is iets misgegaan");
            }
        }).catch(() => console.error);
    }

    const orgName = useMemo(() => {
        return communityList?.find(item => item.iCommunityId === Number(communityId))?.name || ""
    }, [communityId, communityList]);

    return (
        <Fragment>
            <PageHeading orgName={orgName} />
            <TransitionOnLoad>
                <Row className="mb-5">
                    <Col>
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                {communityLoading || featuresLoading ?
                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} /> :
                                    <ReactTableGeneric
                                        data={featuresData?.functieArr || []}
                                        columns={columns}
                                        tableClassName="mb-0 table table-borderless table-sm table-hover tb-api tb-links"
                                        rowCount={40}
                                        filters={{ search: false, pagination: false, sorting: false }}
                                    />
                                }
                            </CardBody>
                        </Card>
                        <p className="mt-4" style={{ color: '#076396' }}>Klik op icoontjes om te wijzigen</p>
                    </Col>
                    <Modal isOpen={functionModal} toggle={toggle} className="feedback-modal-style link-form modal-group-state">
                        <ModalHeader toggle={toggle}>
                            Functie toevoegen
                        </ModalHeader>
                        <ModalBody>
                            <Formik
                                enableReinitialize
                                initialValues={{
                                    functies: '',
                                    eExclude_wwz: 'No',
                                }}
                                validationSchema={validationSchema}
                                onSubmit={handleOrgSubmit}
                            >
                                {({ setFieldValue, handleSubmit, values, handleBlur, errors, touched }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup>
                                            <Label for="functies">Functies</Label>
                                            <select
                                                name="functies"
                                                className="form-control"
                                                value={values.functies}
                                                onChange={(e) => setFieldValue('functies', e.target.value)}
                                                onBlur={handleBlur}
                                            ><option value="">Optional functies</option>
                                                {featuresData?.codeMasterArr?.map(item => <option value={item.iSubGroupId}>{item.vGroup}</option>)}
                                            </select>
                                            {touched.functies && errors.functies && (
                                                <div className="invalid-feedback d-block">{errors.functies}</div>
                                            )}
                                        </FormGroup>
                                        <FormGroup className="d-flex justify-content-between">
                                            <Label for="eExclude_wwz">Uitzondering WW</Label>
                                            <div className="me-3">
                                                <GroupStatus iconChangeHandler={(_, value) => { setFieldValue('eExclude_wwz', value === '0' ? 'No' : 'Yes') }} field={"eExclude_wwz"} data={values.eExclude_wwz === 'Yes' ? 1 : 0} />
                                                {touched.eExclude_wwz && errors.eExclude_wwz && (
                                                    <div className="invalid-feedback d-block">{errors.eExclude_wwz}</div>
                                                )}
                                            </div>
                                        </FormGroup>

                                        <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-4">
                                            <Button className="btn-color-style  opslaan-btn" size="sm" outline color="primary" type="submit">
                                                Toevoegen
                                            </Button>
                                        </ModalFooter>
                                    </Form>
                                )}
                            </Formik>
                        </ModalBody>
                    </Modal>
                </Row>

            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex gap-3 mr-4">
                        <div>
                            <select className={`form-select`} value={communityId} onChange={(e) => { setCommunityId(e.target.value) }}>
                                <option value={''} disabled>Alle besturen</option>
                                {communityList?.map(item => {
                                    return <option key={item.iCommunityId} value={item.iCommunityId}>{item.name}</option>
                                })}
                            </select>
                        </div>
                        <Button
                            outline
                            className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                            onClick={toggle}
                            type="button"
                            color="primary"
                        >
                            Functie <AddIcon />
                        </Button>
                    </div>
                </CardFooter>
            </div>
            <SweetAlert title="Weet u zeker dat u deze selectie wilt verwijderen?" show={showAlert}
                type="warning"
                onConfirm={() => { setShowAlert(false); deleteFunctieHandler() }}
                onCancel={() => setShowAlert(false)}
                cancelBtnText="Nee"
                confirmBtnText="Ja"
                showCancel={true}
            />
        </Fragment>
    )
}

export default Features